import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { ProjectDeviceModel } from "app/models/projectDevice.model";
import { locale as catalan } from "../i18n/ca";
import { locale as english } from "../i18n/en";
import { locale as spanish } from "../i18n/es";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { DeviceEventComponent } from "./device-event/device-event.component";
import { ProjectModel } from "app/models/project.model";
import { DeviceInfoComponent } from "./device-info/device-info.component";

@Component({
    selector: "device",
    templateUrl: "./device.component.html",
    styleUrls: ["./device.component.scss"],
    animations: fuseAnimations,
    standalone: false,
})
export class DeviceComponent implements OnInit {
    device: ProjectDeviceModel;
    project: ProjectModel;
    @ViewChild("tabEvents") events: DeviceEventComponent;
    @ViewChild("tabInfo") info: DeviceInfoComponent;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, spanish, catalan);
    }

    ngOnInit() {
        this.device = this.route.snapshot.data.data;
    }

    onTabChange(event: MatTabChangeEvent) {
        if (event.index == 3) {
            this.events?.loadData();
        }
        if (event.index == 1) {
            //This is a hack as sometimes the graph is not resized right
            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 100);
        }
        if (event.index == 4) {
            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
                this.info?.refreshMapPosition();
            }, 100);
            setTimeout(() => this.info?.refreshMapPosition(), 250);
        }
    }
}
